// Tekster for pipeline pakke 2 (se pipelineViewMessages.ts). Egen fil så
// delene av pakken kan bygges hver for seg. Her: «Å gjøre» på Oversikten
// (kap. 8.6), Muligheter-fanen på kundekortet (kap. 16.4) og neste steg i
// kundestatusen (kap. 7.1).
export const norwegianPipelineTodayMessages = {
  crm: {
    dashboard: {
      today: {
        group: {
          deal_overdue: "Forfalte neste steg",
          overdue: "Forfalt",
          deal_today: "Neste steg i dag",
          today: "I dag",
          leads_unowned: "Leads uten eier",
          deal_no_step: "Muligheter uten neste steg",
          deal_rotting: "Råtnende muligheter",
          offer_expiring: "Tilbud som utløper snart",
          upcoming: "Kommende",
          undated: "Uten dato",
        },
        kind: {
          oppgave: "Oppgave",
          kunde_steg: "Neste steg",
          neste_steg: "Neste steg",
          mulighet: "Mulighet",
          lead: "Lead",
          fornyelse: "Fornyelse",
          oppfolging: "Ring tilbake",
        },
        capped_tasks: "Viser %{shown} av %{total} åpne oppgaver",
        capped_customer_steps: "Viser %{shown} av %{total} neste steg",
        capped_open_deals: "Viser %{shown} av %{total} åpne muligheter",
        capped_renewals: "Viser %{shown} av %{total} fornyelser",
        capped_notes: "Viser %{shown} av %{total} oppfølginger",
        no_next_step: "Ingen neste steg",
        silent_days:
          "Stille i %{smart_count} dag |||| Stille i %{smart_count} dager",
        offer_expires_today: "Tilbudet utløper i dag",
        offer_expires_in:
          "Utløper om %{smart_count} dag |||| Utløper om %{smart_count} dager",
        claim: "Ta denne",
        claim_named: "Ta denne: %{name}",
        claimed: "%{name} er din nå",
      },
    },
    company_deals: {
      tab: "Muligheter",
      status: "Vis muligheter",
      tab_open: "Åpne",
      tab_won: "Vunnet",
      tab_lost: "Tapt",
      empty_open: "Ingen åpne muligheter.",
      empty_won: "Ingen vunne muligheter.",
      empty_lost: "Ingen tapte muligheter.",
      no_next_step: "Ingen neste steg",
      today: "i dag",
      next: "Neste steg: %{title} · %{date}",
      next_overdue: "Forfalt: %{title} · %{date}",
    },
    summary: {
      deal_no_next_step: "Ingen neste steg",
    },
  },
};

export const englishPipelineTodayMessages = {
  crm: {
    dashboard: {
      today: {
        group: {
          deal_overdue: "Overdue next steps",
          overdue: "Overdue",
          deal_today: "Next steps today",
          today: "Today",
          leads_unowned: "Unowned leads",
          deal_no_step: "Opportunities without a next step",
          deal_rotting: "Rotting opportunities",
          offer_expiring: "Offers expiring soon",
          upcoming: "Upcoming",
          undated: "No date",
        },
        kind: {
          oppgave: "Task",
          kunde_steg: "Next step",
          neste_steg: "Next step",
          mulighet: "Opportunity",
          lead: "Lead",
          fornyelse: "Renewal",
          oppfolging: "Call back",
        },
        capped_tasks: "Showing %{shown} of %{total} open tasks",
        capped_customer_steps: "Showing %{shown} of %{total} next steps",
        capped_open_deals: "Showing %{shown} of %{total} open opportunities",
        capped_renewals: "Showing %{shown} of %{total} renewals",
        capped_notes: "Showing %{shown} of %{total} follow-ups",
        no_next_step: "No next step",
        silent_days:
          "Silent for %{smart_count} day |||| Silent for %{smart_count} days",
        offer_expires_today: "Offer expires today",
        offer_expires_in:
          "Expires in %{smart_count} day |||| Expires in %{smart_count} days",
        claim: "Take this",
        claim_named: "Take this: %{name}",
        claimed: "%{name} is yours now",
      },
    },
    company_deals: {
      tab: "Opportunities",
      status: "Show opportunities",
      tab_open: "Open",
      tab_won: "Won",
      tab_lost: "Lost",
      empty_open: "No open opportunities.",
      empty_won: "No won opportunities.",
      empty_lost: "No lost opportunities.",
      no_next_step: "No next step",
      today: "today",
      next: "Next step: %{title} · %{date}",
      next_overdue: "Overdue: %{title} · %{date}",
    },
    summary: {
      deal_no_next_step: "No next step",
    },
  },
};
